import { Box, Typography } from '@mui/material';
import ShopHeader from 'components/ShopHeader';
import WaitNumber from 'components/WaitNumber';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as BGImage } from 'assets/images/standby/call-image--1.svg';

const CallMeasurement = () => {
  const storeInfo = useSelector((state: RootState) => state.store);
  const receiptInfo = useSelector(
    (state: RootState) => state.receipt.max_priority,
  );
  const extStatusInfo = useSelector(
    (state: RootState) => state.receipt.ext_status,
  );
  const navigate = useNavigate();

  useEffect(() => {
    console.log('測定呼出...');
  }, []);

  useEffect(() => {
    const ext_status =
      receiptInfo?.receipt_no &&
      extStatusInfo[receiptInfo.receipt_no]?.ext_state;

    if (
      !(
        receiptInfo?.ticket_status === '110' ||
        receiptInfo?.ticket_status === '120' ||
        receiptInfo?.ticket_status === '190' ||
        receiptInfo?.ticket_status === '191' ||
        receiptInfo?.ticket_status === '192' ||
        (receiptInfo?.ticket_status === '100' && ext_status === '100_ext')
      )
    ) {
      navigate('/');
    }
  }, [receiptInfo]);

  return (
    <Box sx={{ backgroundColor: '#E9FDF9', minHeight: '100vh' }}>
      <Box
        sx={{
          backgroundColor: '#c7e4d6',
          background:
            'linear-gradient(180deg, rgba(199,228,214,1) 0%, rgba(199,228,214,1) 98%, rgba(233,253,249,1) 99%, rgba(233,253,249,1) 100%)',
          pt: 6,
        }}
      >
        <Box sx={{ pl: 4, pr: 4 }}>
          <Box>
            <ShopHeader shopName={storeInfo.store_name || ''} />
          </Box>
          <Box sx={{ mt: 4 }}>
            <Box
              sx={{
                backgroundColor: '#ffffff',
                borderRadius: '15px',
                paddingTop: 4,
                pl: 4,
                pr: 4,
                pb: 4,
              }}
            >
              <Box>
                <Typography
                  textAlign={'center'}
                  sx={{
                    fontSize: 24,
                    lineHeight: 35 / 24,
                    fontWeight: 500,
                    color: '#000000',
                  }}
                >
                  お待たせしました！
                </Typography>
              </Box>
              <Box sx={{ mt: '3px' }}>
                <Typography
                  textAlign={'center'}
                  sx={{
                    fontSize: 14,
                    lineHeight: 20 / 14,
                    fontWeight: 500,
                    color: '#000000',
                  }}
                >
                  測定の順番となりました。
                  <br />
                  受付カウンターまでお越しいただき、スタッフにこちらの画面をご提示ください。
                </Typography>
              </Box>
              <Box sx={{ mt: 2 }}>
                <WaitNumber
                  type={'a'}
                  number={
                    receiptInfo?.ticket_number !== undefined
                      ? receiptInfo.ticket_number
                      : '-'
                  }
                ></WaitNumber>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            mt: 10,
            '& > svg': {
              display: 'block',
              width: '100%',
              height: 'auto',
            },
          }}
        >
          <BGImage></BGImage>
        </Box>
      </Box>
    </Box>
  );
};
export default CallMeasurement;
